<template>
        <v-app-bar app color="white">
            <v-toolbar-title>
                <router-link to="/home">
                    <img :src="imgSrc"
                         style="max-height: 40px">
                    </img>
                </router-link>
            </v-toolbar-title>

            <v-spacer></v-spacer>

            <v-toolbar-items >
                <v-btn  class="hidden-sm-and-down"
                        v-for="(item, key) in items"
                        :key="key"
                        :to="item.to"
                        large
                        text>
                    <v-icon left v-if="item.icon">
                        {{item.icon}}
                    </v-icon> {{item.title}}
                </v-btn>

                <v-menu bottom left max-width="100px">
                    <template v-slot:activator="{ on }">
                        <v-btn class="hidden-md-and-up"
                               icon
                               v-on="on"
                        >
                            <v-icon>mdi-dots-vertical</v-icon>
                        </v-btn>
                    </template>
                    <v-list>
                        <v-list-item-title
                                v-for="(item, i) in items"
                                :key="i"
                                @click=""
                        >
                            <v-list-item-action>
                                <v-btn
                                        :to="item.to"
                                        md
                                        text>
                                    <v-icon left v-if="item.icon">
                                        {{item.icon}}
                                    </v-icon> {{item.title}}
                                </v-btn>
                            </v-list-item-action>
                        </v-list-item-title>
                    </v-list>
                </v-menu>

            </v-toolbar-items>


        </v-app-bar>
</template>

<script>
    export default {
        name: "homeHeader",
        data(){
            return{
                imgSrc: require('../../../assets/img/Full Color outlined_H.png'),
                items: [
                    {   title: 'ABOUT',
                        to: '',
                        icon: ''
                    },
                    {   title: 'CONTACT',
                        to: '',
                        icon: ''
                    },
                    {   title: 'LOGIN',
                        to: '/login',
                        icon: 'ub-login'
                    },
                ]
            }
        }
    }
</script>

<style scoped>

</style>